import { writable } from 'svelte/store';
export const lockState = writable({
    video : true,
    caption : false,
    preview : true
});